import LabourerForm from "./LabourerForm";

import { getSydneyDateObject, toApiDateTime } from "../utils/dateUtils";

const UpdateLabourerForm = ({ labourer, isLoading, onSubmit, onCloseClicked }) => {
  const handleSubmit = ({ fullName, email, dateOfBirth, onboardingDate, offboardingDate }) => {
    const payload = {
      fullName,
      email,
      dateOfBirth: dateOfBirth ? toApiDateTime(dateOfBirth) : null,
      onboardingDate: onboardingDate ? toApiDateTime(onboardingDate) : null,
      offboardingDate: offboardingDate ? toApiDateTime(offboardingDate) : null,
    };

    onSubmit(payload);
  };

  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-[600px] pb-1">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white p-4 font-bold rounded-t-md">
        <p>Update Labourer</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <LabourerForm
        initialFullName={labourer?.user?.fullName}
        initialEmail={labourer?.user?.email}
        initialDateOfBirth={labourer?.user?.dateOfBirth ? getSydneyDateObject(labourer.user.dateOfBirth) : null}
        initialOnboardingDate={labourer?.onboardingDate ? getSydneyDateObject(labourer.onboardingDate) : null}
        initialOffboardingDate={labourer?.offboardingDate ? getSydneyDateObject(labourer.offboardingDate) : null}
        isLoading={isLoading}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default UpdateLabourerForm;
